module.exports = __webpack_public_path__ + "img/card_rome_background.5c941571.png";